import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useRef,
  useState
} from 'react'

import {
  Botao,
  InputUnform,
  FormUnform,
  ModalBase,
  FormRef,
  CheckboxUnform
} from 'src/componentes'
import { EditorUnform } from 'src/componentes/unform/editor'
import { mensagemPadrao } from 'src/dados-estaticos'
import { ContainerBotoes, SubtituloModal } from 'src/paginas/ipgs/turmas/styles'
import { Api } from 'src/servicos'
import * as Yup from 'yup'

import { ContainerCheckbox, ModalCorpo } from './styles'
import { ModalIncluirTopicoProps, ModalIncluirTopicoRef } from './tipos'

const Componente: ForwardRefRenderFunction<
  ModalIncluirTopicoRef,
  ModalIncluirTopicoProps
> = ({ backdrop, aberta, acaoSucesso }, ref) => {
  const [aberto, definirAberto] = useState(aberta)
  const [pronto, definirPronto] = useState(false)
  const [carregando, definirCarregando] = useState(false)
  const [turmaId, definirTurmaId] = useState<string>(null)
  const [possuiComentariosBloqueados, definirComentariosBloqueados] = useState(
    false
  )
  const formRef = useRef<FormRef>()

  const abrir = turmaId => {
    definirTurmaId(turmaId)
    definirAberto(true)
    definirPronto(true)
  }

  const fechar = () => {
    definirTurmaId(null)
    definirPronto(false)
    definirAberto(false)
  }

  const acaoSucessoForm = async (payload: {
    titulo: string
    textoApoio: string
    comentariosBloqueados: boolean
  }) => {
    try {
      definirCarregando(true)

      await Api.CriarTopico({ ...payload, turmaId: turmaId })

      acaoSucesso()
      definirComentariosBloqueados(false)
      fechar()
    } finally {
      definirCarregando(false)
    }
  }

  useImperativeHandle<ModalIncluirTopicoRef, ModalIncluirTopicoRef>(
    ref,
    () => ({
      fechar,
      abrir
    })
  )

  return (
    <ModalBase aberta={aberto} backdrop={backdrop}>
      <ModalCorpo>
        <SubtituloModal>Incluir Tópico</SubtituloModal>
        {pronto && (
          <FormUnform
            ref={formRef}
            acaoSucesso={acaoSucessoForm}
            schema={Yup.object().shape({
              titulo: Yup.string().required(mensagemPadrao)
            })}
          >
            <InputUnform
              name="titulo"
              label="Informe o título para o seu tópico"
              obrigatorio
            />
            <EditorUnform
              name="textoApoio"
              id="textoApoio"
              label="Texto de apoio"
            />
            <ContainerCheckbox>
              <CheckboxUnform
                id="chk_comentarios_bloqueados"
                name="comentariosBloqueados"
                onChange={() => definirComentariosBloqueados(old => !old)}
                checked={possuiComentariosBloqueados}
              />
              <p>Não permitir comentários.</p>
            </ContainerCheckbox>
            <ContainerBotoes>
              <Botao
                type="button"
                texto="Cancelar"
                tema="Secundario"
                onClick={() => {
                  fechar()
                }}
                disabled={carregando}
              />
              <Botao
                type="button"
                id="btn-salvar"
                texto="Salvar"
                carregando={carregando}
                onClick={() => formRef?.current?.submitForm()}
              />
            </ContainerBotoes>
          </FormUnform>
        )}
      </ModalCorpo>
    </ModalBase>
  )
}

export const ModalIncluirTopico = forwardRef(Componente)
